import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import type { PrivatePensionStepParams } from './types'
import { investMoneySchema } from './types'

export const invest_money = (params: PrivatePensionStepParams) => {
  const schema = investMoneySchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_privatePension:steps.invest.title',
        },
      },
      {
        type: 'choice',
        options:
          schema.shape.products.shape.mga_private_pension_de.shape.configuration_parameters.shape.invest_money.options.map(
            (option) => ({
              value: option,
              label: {
                type: 'translatableText',
                translationKey: `sharedFlows_privatePension:steps.invest.options.${option}`,
              },
            })
          ),
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('invest_money'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStep: 'employment_status',
    hideBackButton: params.getCurrentLanguage() === 'de',
    subFlow: SubFlow.PrivatePension,
  } as const satisfies AnyStepConfiguration
}
